import Select from "react-select";

import { useTranslation } from "react-i18next";
import { CiFilter, CiSearch } from "react-icons/ci";
import BackButton from "../../../../components/modals/AddAssetModal/BackButton/BackButton";
import { useSearchParams } from "react-router-dom";
// import { FaSortAmountDown, FaSortAmountUp } from "react-icons/fa";
import {
  HiOutlineSortDescending,
  HiOutlineSortAscending,
} from "react-icons/hi";
import html2canvas from "html2canvas";
import jsPdf from "jspdf";
import { useReportForm } from "../context/reportFormContext";

interface Props {
  isLoading: string;
  getReport: any;
  reportsOrVoiceReports: any;
  report: any;
  versionsCount: number;
  versionOptions: any[];
  reportVersion: number;
  setReportVersion: any;
  searchValue: string;
  setSearchValue: any;
  reportAnswers: any[];
  reportAnswersFlow: any[];
  toggleFilter: boolean;
  setToggleFilter: any;
  setToggleExportModal: any;
  setNestedTable: any;
  handleSelectFormIds: any;
  handleSelectQuestionIds: any;
}

export default function ReportAnswersFilters({
  isLoading,
  getReport,
  reportsOrVoiceReports,
  report,
  versionsCount,
  versionOptions,
  reportVersion,
  setReportVersion,
  searchValue,
  setSearchValue,
  toggleFilter,
  setToggleFilter,
  setToggleExportModal,
  setNestedTable,
  handleSelectFormIds,
  handleSelectQuestionIds,
}: Props) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { setIsTakingSnapshot, isTakingSnapshot } = useReportForm();
  const sort = searchParams.get("sort");

  return (
    <>
      {(reportsOrVoiceReports === "static" ||
        reportsOrVoiceReports === "dynamic") &&
        isLoading !== "report" && (
          <div className="flex justify-between items-center max-xl:items-start max-xl:gap-5 max-xl:flex-col mt-20">
            <div className="flex items-center gap-2">
              {report?.report_type?.includes("nested") && (
                <BackButton
                  cb={() => {
                    setNestedTable(null);
                    handleSelectFormIds("", true);
                    handleSelectQuestionIds("", true);
                  }}
                />
              )}
              <div
                className={`text-3xl font-bold ${
                  !report?.report_title && "hidden"
                }`}
              >
                {report?.report_title}
              </div>
            </div>
            <div className="flex items-center gap-5">
              {report?.report_title && report?.answers?.length !== 0 && (
                <>
                  <button
                    className={`main_btn cursor-pointer capitalize ${report?.report_type?.includes("nested") ? "hidden" : ""}`}
                    onClick={() => {
                      setIsTakingSnapshot(true);

                      // Use requestAnimationFrame for smoother rendering
                      requestAnimationFrame(() => {
                        setTimeout(async () => {
                          const table =
                            document.getElementById("answers-table");

                          if (table) {
                            try {
                              // Capture the table as a canvas with optimized settings
                              const canvas = await html2canvas(table, {
                                useCORS: true, // Ensure images from external sources are included
                                scale: 2, // Improve image quality (adjustable based on need)
                                logging: false, // Disable logging to the console for better performance
                                allowTaint: false, // Prevent cross-origin issues
                                onclone: (document) => {
                                  Array.from(
                                    document.querySelectorAll("*")
                                  ).forEach((e) => {
                                    let existingStyle =
                                      e.getAttribute("style") || "";
                                    e.setAttribute(
                                      "style",
                                      existingStyle +
                                        "; font-family: Helvetica, sans-serif !important"
                                    );
                                  });
                                },
                              });

                              // Create a download link for the image
                              const link = document.createElement("a");
                              link.download = "table-screenshot.png";
                              link.href = canvas.toDataURL("image/webp", 0.8); // Use compression to reduce file size
                              link.click();
                            } catch (error) {
                              console.error("Error capturing table:", error);
                            } finally {
                              setIsTakingSnapshot(false);
                            }
                          } else {
                            console.warn("Table element not found.");
                            setIsTakingSnapshot(false);
                          }
                        }, 500); // Reduce timeout duration if possible
                      });

                      // const pdf = new jsPdf(); // Create a new jsPDF instance

                      // const table = document.getElementById("answers-table");
                      // const canvas = await html2canvas(table!); // Capture the table as a canvas
                      // const imgData = canvas.toDataURL("image/png"); // Convert canvas to image data

                      // const imgWidth = 195; // Width of the image in the PDF (A4 width minus margins)
                      // const imgHeight = (canvas.height * imgWidth) / canvas.width; // Calculate proportional height

                      // let position = 0; // Start position for the first page

                      // // Add image to PDF
                      // pdf.addImage(
                      //   imgData,
                      //   "PNG",
                      //   10,
                      //   position + 10,
                      //   imgWidth,
                      //   imgHeight
                      // );

                      // // Save the PDF
                      // pdf.save("table.pdf");
                    }}
                  >
                    {t("take_a_snapshot")}
                  </button>

                  <button
                    className={`main_btn cursor-pointer capitalize ${report?.report_type?.includes("nested") ? "hidden" : ""}`}
                    onClick={() => setToggleExportModal(true)}
                  >
                    {t("export")}
                  </button>
                </>
              )}
              {report?.report_title &&
                versionsCount > 1 &&
                !report?.report_type?.includes("nested") && (
                  <Select
                    className="w-44"
                    options={versionOptions.sort((a: any, b: any) => {
                      return b.value - a.value;
                    })}
                    value={versionOptions.find(
                      (option: any) => option.value === reportVersion
                    )}
                    onChange={(selectedOption) => {
                      setReportVersion(selectedOption?.value as number);
                      // getReportVersion(selectedOption?.value as number);
                    }}
                    key={"reportVersion" + report.version}
                    placeholder={t("select_report_version")}
                  />
                )}
              {report?.report_title &&
                !report?.report_type?.includes("nested") && (
                  <>
                    <form
                      className="flex items-center gap-2 border border-secondary_text rounded-md px-2"
                      onSubmit={(e) => {
                        e.preventDefault();
                        setSearchParams((prev: any) => {
                          prev.set("page", "1");
                          return prev;
                        });
                        getReport();
                      }}
                    >
                      <button type="submit" className="text-xl cursor-pointer">
                        <CiSearch />
                      </button>
                      <input
                        type="search"
                        name="search"
                        id="search"
                        placeholder={t("search")}
                        className="border-none focus:outline-none min-w-[50px] bg-transparent"
                        onChange={(e) => setSearchValue(e.target.value)}
                        value={searchValue}
                      />
                    </form>

                    <div className="flex items-center gap-2">
                      <button
                        type="button"
                        className="text-3xl cursor-pointer text-secondary_text hover:text-text duration-200"
                        onClick={() => {
                          setSearchParams((prev: any) => {
                            if (sort === "reverse") {
                              prev.delete("sort");
                            } else {
                              prev.set("sort", "reverse");
                            }
                            return prev;
                          });
                        }}
                      >
                        {sort === "reverse" ? (
                          <HiOutlineSortDescending />
                        ) : (
                          <HiOutlineSortAscending />
                        )}
                      </button>
                      <CiFilter
                        className="text-4xl cursor-pointer text-secondary_text hover:text-text duration-200 toggleFilter"
                        onClick={() => setToggleFilter(!toggleFilter)}
                      />
                    </div>
                  </>
                )}
            </div>
          </div>
        )}
    </>
  );
}
